// src/redux/actions/attendanceActionTypes.js
export const FETCH_ATTENDANCE_REQUEST = 'FETCH_ATTENDANCE_REQUEST';
export const FETCH_ATTENDANCE_SUCCESS = 'FETCH_ATTENDANCE_SUCCESS';
export const FETCH_ATTENDANCE_FAILURE = 'FETCH_ATTENDANCE_FAILURE';

export const ADD_ATTENDANCE_REQUEST = 'ADD_ATTENDANCE_REQUEST';
export const ADD_ATTENDANCE_SUCCESS = 'ADD_ATTENDANCE_SUCCESS';
export const ADD_ATTENDANCE_FAILURE = 'ADD_ATTENDANCE_FAILURE';

export const UPDATE_ATTENDANCE_REQUEST = 'UPDATE_ATTENDANCE_REQUEST';
export const UPDATE_ATTENDANCE_SUCCESS = 'UPDATE_ATTENDANCE_SUCCESS';
export const UPDATE_ATTENDANCE_FAILURE = 'UPDATE_ATTENDANCE_FAILURE';

export const DELETE_ATTENDANCE_REQUEST = 'DELETE_ATTENDANCE_REQUEST';
export const DELETE_ATTENDANCE_SUCCESS = 'DELETE_ATTENDANCE_SUCCESS';
export const DELETE_ATTENDANCE_FAILURE = 'DELETE_ATTENDANCE_FAILURE';
